export enum FieldBaseType {
  string = 'string',
  number = 'number',
  boolean = 'boolean'
}
